// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"3951cbe8","368":"65f3b88f","389":"e1a54206","672":"2f296ded","749":"e24c78dd"}[chunkId] + ".chunk.js";
};